// "use strict";

import jQuery from 'jquery'
global.$ = jQuery
window.$ = jQuery

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

$(document).on('turbolinks:load', () => {
  $(function() {
    // drawer accordion
    const drawerAccordion = function() {
      var accordions = document.querySelectorAll('.accordion .accordion-label');
      accordions.forEach(function (clickedItem) {
        clickedItem.addEventListener('click', function () {
          clickedItem.parentNode.classList.toggle('is-active');
        });
      });
    };
  
    // リロード後１クリック目はモーダルが開かない件の暫定対応
    //modal
    // const modalContainer = function() {
    //   var opens = document.querySelectorAll('.modal-open');
    //   var closes = document.querySelectorAll('.modal-close');
    //   opens.forEach(function (clickedItem) {
    //     clickedItem.addEventListener('click', function (e) {
    //       e.preventDefault();
    //       document.getElementById(clickedItem.dataset.id).classList.add('is-active');
    //       document.body.classList.add('is-fixed');
    //     });
    //   });
    //   closes.forEach(function (clickedItem) {
    //     clickedItem.addEventListener('click', function () {
    //       clickedItem.parentNode.parentNode.classList.toggle('is-active');
    //       document.body.classList.remove('is-fixed');
    //     });
    //   });
    // };

    //credit Card form
    const radioAccordion = function() {
      var radioButton = document.querySelectorAll("input[type='radio'][name='creditCardForm']");
      var radioContent = document.getElementById('new-creditcard-form');
  
      var _iterator = _createForOfIteratorHelper(radioButton),
          _step;
  
      try {
        var _loop = function _loop() {
          var target = _step.value;
  
          if (target.value === 'new' && target.checked) {
            radioContent.classList.add('is-active');
          }
  
          target.addEventListener("change", function () {
            if (target.value === 'new') {
              radioContent.classList.add('is-active');
            } else {
              radioContent.classList.remove('is-active');
            }
          });
        };
  
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    
    drawerAccordion();
    // modalContainer();
    radioAccordion();
  }) // drawer

  $(function () {
    $('.header .drawer-button, #drawer-button ,#drawer-menu .button-close').click(function () {
      $("#drawer-menu").toggleClass('is-active');
    });
  }) // page scroll
  
  $(function () {
    $('a[href^="#"]').click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  });
})